/**
 * Maps a numeric series to a polyline `points` string, 40×16 by default.
 *
 * Exported because the Manage landing page's budget-status card draws the same
 * kind of inline trend line at its own size — one definition of "how we plot a
 * sparkline" rather than two that drift.
 */
export const sparklinePoints = (series: number[], w = 40, h = 16, pad = 1.5): string => {
  const min = Math.min(...series);
  const max = Math.max(...series);
  const span = max - min || 1;
  const step = series.length > 1 ? (w - pad * 2) / (series.length - 1) : 0;
  return series
    .map((v, i) => {
      const x = pad + i * step;
      const y = h - pad - ((v - min) / span) * (h - pad * 2);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
};
